import { createFileRoute } from "@tanstack/react-router";
import { WishlistPage, wishlistHeadDa } from "@/pages/WishlistPage";

export const Route = createFileRoute("/onskeliste")({
  head: wishlistHeadDa,
  component: WishlistPage,
});
